// ─── User preference keys ──────────────────────────────────────────────────────

/** The user's choice to dismiss the onboarding wizard without completing it. Category is
 * `FRONTOFFICE` (see `USER_PREFERENCE_CATEGORY`). */
export const ONBOARDING_WIZARD_SKIPPED_PREFERENCE_KEY = 'onboarding-wizard-skipped';
